import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import {Button, Tooltip} from '@mui/material'
import type {FC, ReactElement} from 'react'
import {useNavigate} from 'react-router-dom'
import {useCustomTranslation} from '@shared/hooks/useCustomTranslation'
import {useHasV2App} from '@shared/hooks/useV2App'
import {setNavigationExperience} from '@shared/utils/navigationExperience'

/**
 * Back to the new experience (AB#6639) for a user with the `ui_v2_experience` flag who
 * switched to classic; the new one's app bar and profile menu lead here.
 * Lands on Home, since not every page exists in both.
 */
const V2AppSwitch: FC = (): ReactElement | null => {
  const [t] = useCustomTranslation('common')
  const navigate = useNavigate()
  const flagged = useHasV2App()
  if (!flagged) {
    return null
  }

  return (
    <Tooltip title={t('appbar.switch_to_new_tooltip')}>
      <Button
        data-testid="mbai-v2-app-switch"
        size="small"
        variant="outlined"
        startIcon={<SwapHorizIcon />}
        onClick={() => {
          setNavigationExperience('new')
          navigate('/home', {replace: true})
        }}
        sx={{whiteSpace: 'nowrap', textTransform: 'none'}}
      >
        {t('appbar.switch_to_new')}
      </Button>
    </Tooltip>
  )
}

export default V2AppSwitch
